import { jwtDecode } from 'jwt-decode';

export function decodeTokenClaims(token) {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

export function getEmailFromToken(token) {
  const claims = decodeTokenClaims(token);
  const email = claims?.email ?? claims?.sub ?? '';
  return String(email).trim();
}

export function getRoleFromToken(token) {
  const claims = decodeTokenClaims(token);
  const role = claims?.role ?? '';
  return String(role).trim();
}

export function getEmployeeIdFromToken(token) {
  const claims = decodeTokenClaims(token);
  const id =
    claims?.employeeId ?? claims?.EmployeeId ?? claims?.employee_id ?? '';
  return String(id).trim();
}

/** True when JWT exp is in the past (optional leeway in seconds). */
export function isAccessTokenExpired(token, leewaySeconds = 60) {
  const claims = decodeTokenClaims(token);
  if (!claims?.exp) return false;
  return Date.now() >= claims.exp * 1000 - leewaySeconds * 1000;
}

/** Remaining JWT lifetime in seconds (from exp claim). */
export function getTokenMaxAgeSeconds(token) {
  const claims = decodeTokenClaims(token);
  if (!claims?.exp) return undefined;
  const remaining = Math.floor(claims.exp - Date.now() / 1000);
  return remaining > 0 ? remaining : undefined;
}

/** Extract employeeId from getemail-admin-details (and similar) payloads. */
export function parseEmployeeIdFromAdminDetails(data) {
  if (!data || typeof data !== 'object') return '';
  const inner = data.user ?? data.data ?? data.admin ?? data.record;
  const src = inner && typeof inner === 'object' ? { ...data, ...inner } : data;
  const id = src.employeeId ?? src.EmployeeId ?? '';
  return String(id).trim();
}
